module.exports = __webpack_public_path__ + "static/media/2nd.cb3e29fd.jpg";